import { requestWithToken } from '../utilities/request';
const path = '/api/private/fields/';

const select = (fieldId, targetDate, workHourZone) => {
  return requestWithToken({
    method: 'GET',
    url: path.concat(`${fieldId}/safety_duties`),
    params: {
      field_id: fieldId,
      work_date: targetDate,
      work_hour_zone: workHourZone,
    },
  });
};

const register = (fieldId, params) => {
  return requestWithToken({
    method: 'POST',
    url: path.concat(`${fieldId}/safety_duties`),
    data: params,
  });
};

const kikanRegister = (fieldId, params) => {
  return requestWithToken({
    method: 'POST',
    url: path.concat(`${fieldId}/safety_duties/create_list`),
    data: params,
  });
};

const deleteDuty = (fieldId, params) => {
  return requestWithToken({
    method: 'DELETE',
    url: path.concat(`${fieldId}/safety_duties/delete`),
    data: params,
  });
};

const kikanDelete = (fieldId, params) => {
  return requestWithToken({
    method: 'DELETE',
    url: path.concat(`${fieldId}/safety_duties/delete_list`),
    data: params,
  });
};

export const SafetyDutyService = {
  select,
  register,
  deleteDuty,
  kikanRegister,
  kikanDelete,
};
export default SafetyDutyService;



// WEBPACK FOOTER //
// ./src/services/SafetyDuties.js